<div *ngIf="images" class="navigation-wrapper">
    <div class="keen-slider" #sliderRef>
        <div
            class="keen-slider__slide preview-tile d-flex align-items-center"
            [ngClass]="{'active' : gi === currentSlide}"
            *ngFor="let pi of images; let gi = index"
            (click)="currentSlide = gi">
            <img class="img-fluid" [src]="pi.url">
        </div>
    </div>

    <ng-container *ngIf="showNav">
        <svg-icon
            src="assets/images/icon-arrow-slider-left.svg"
            [ngClass]="'arrow arrow--left ' + ( currentSlide === 0 ? 'arrow--disabled' : '')"
            [style.fill]="arrowColour"
            (click)="slidePrev()"
            aria-hidden="true"
            focusable="false">
        </svg-icon>
        <svg-icon
            *ngIf="slider"
            src="assets/images/icon-arrow-slider-right.svg"
            [ngClass]="'arrow arrow--right ' + (slider.details().size - 1 === currentSlide ? 'arrow--disabled' : '')"
            [style.fill]="arrowColour"
            (click)="slideNext()"
            aria-hidden="true"
            focusable="false">
        </svg-icon>
    </ng-container>

</div>
<div class="d-flex justify-content-center pt-4" *ngIf="showDots">
    <button
        (click)="slider.moveToSlideRelative(i)"
        *ngFor="let slide of dotHelper; let i = index"
        [class]="'dot ' + (i === currentSlide ? 'active' : '')"
    ></button>
</div>
